import { render, staticRenderFns } from "./document-list.vue?vue&type=template&id=1c66e4bb&lang=pug&"
import script from "./document-list.vue?vue&type=script&lang=ts&"
export * from "./document-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports